export const meta = {
  id: 'A10',
  slug: 'concluir-uma-aula',
  title: 'Como concluir uma aula',
  description: 'Finalize uma aula corretamente para que seu progresso seja atualizado.',
  profile: 'student',
  category: 'treinamentos',
  type: 'task',
  status: 'published',
  order: 140,
  keywords: ['aula', 'concluir aula', 'marcar como concluído', 'progresso', 'próxima aula'],
  previous: 'A09',
  next: 'A11',
  related: ['A09', 'A13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como concluir uma aula

Quando terminar o conteúdo de uma aula, utilize a ação **Marcar como concluído** quando ela estiver disponível.

## Como fazer

<Steps>
  <Step title="Consuma o conteúdo da aula">
    Leia, assista ou consulte os recursos apresentados.
  </Step>
  <Step title="Marque a aula como concluída">
    Use a ação de conclusão disponível na tela.
  </Step>
  <Step title="Continue para a próxima aula">
    A navegação do Treinamento indicará a sequência disponível.
  </Step>
</Steps>

<HelpImage alt="Aula com ação Marcar como concluído" pendingId="A10.3" />

## O que a conclusão atualiza

A conclusão pode alimentar a sequência **Aula → Treinamento → Componente → Etapa → Formação → próxima ação**, conforme os vínculos existentes no seu percurso.

<Callout type="tip">
  No desktop, a navegação pode aparecer na lateral. No celular, ela se adapta para uma visualização mais compacta.
</Callout>
